// Merkezi ürün verileri - Excel'den alınan doğru veriler
const productData = [
  {
    id: 1,
    model: "IP 25",
    name: "Alas Aerosol Yangın Söndürücü 25 Gram",
    name_en: "Alas Aerosol Fire Extinguisher 25 Gram",
    weight_kg: "1,15±0,05",
    dimensions_mm: "85*82*85",
    width_mm: 85.0,
    depth_mm: 82.0,
    height_mm: 85.0,
    effective_mass: 16.8, // 28 * 0.6
    min_height: 0.9, // Excel: En Düşük Montaj Yüksekliği 90cm
    max_height: 1.0, // Excel: En Yüksek Montaj Yüksekliği 100cm
    mass: 1.15,
    contained_agent: 28,
    effective_mass_percentage: 60, // Excel'de 0.6 olarak görünüyor ama %60
    class_a_capacity: 0.3377, // Excel: 0.3376884422110553
    class_b_capacity: 0.2243, // Excel: 0.22432901588997198
    safe_distance: 0 // Excel'de "-" (yok)
  },
  {
    id: 2,
    model: "IP 55",
    name: "Alas Aerosol Yangın Söndürücü 55 Gram",
    name_en: "Alas Aerosol Fire Extinguisher 55 Gram",
    weight_kg: "1,55±0,05",
    dimensions_mm: "116*82*85",
    width_mm: 116.0,
    depth_mm: 82.0,
    height_mm: 85.0,
    effective_mass: 30.8, // 56 * 0.55
    min_height: 0.9, // Excel: En Düşük Montaj Yüksekliği 90cm
    max_height: 1.0, // Excel: En Yüksek Montaj Yüksekliği 100cm
    mass: 1.55,
    contained_agent: 56,
    effective_mass_percentage: 55, // Excel'de 0.55 olarak görünüyor ama %55
    class_a_capacity: 0.6191, // Excel: 0.6190954773869347
    class_b_capacity: 0.4113, // Excel: 0.4112698624649486
    safe_distance: 0 // Excel'de "-" (yok)
  },
  {
    id: 3,
    model: "IP 110",
    name: "Alas Aerosol Yangın Söndürücü 110 Gram",
    name_en: "Alas Aerosol Fire Extinguisher 110 Gram",
    weight_kg: "1,85±0,05",
    dimensions_mm: "105*100*100",
    width_mm: 105.0,
    depth_mm: 100.0,
    height_mm: 100.0,
    effective_mass: 61.6, // 112 * 0.55
    min_height: 0.9, // Excel: En Düşük Montaj Yüksekliği 90cm
    max_height: 1.0, // Excel: En Yüksek Montaj Yüksekliği 100cm
    mass: 1.85,
    contained_agent: 112,
    effective_mass_percentage: 55, // Excel'de 0.55 olarak görünüyor ama %55
    safe_distance: 0.1, // Excel'de 10cm -> 0.1m
    class_a_capacity: 1.2382, // Excel: 1.2381909547738694
    class_b_capacity: 0.8225 // Excel: 0.8225397249298972
  },
  {
    id: 4,
    model: "IP 220",
    name: "Alas Aerosol Yangın Söndürücü 220 Gram",
    name_en: "Alas Aerosol Fire Extinguisher 220 Gram",
    weight_kg: "2,2±0,05",
    dimensions_mm: "129*100*100",
    width_mm: 129.0,
    depth_mm: 100.0,
    height_mm: 100.0,
    effective_mass: 132, // 220 * 0.6
    min_height: 0.9, // Excel: En Düşük Montaj Yüksekliği 90cm
    max_height: 1.2, // Excel: En Yüksek Montaj Yüksekliği 120cm
    mass: 2.2,
    contained_agent: 220,
    effective_mass_percentage: 60, // Excel'de 0.6 olarak görünüyor ama %60
    safe_distance: 0.65, // Excel'de 65cm -> 0.65m
    class_a_capacity: 2.6533, // Excel: 2.6532663316582914
    class_b_capacity: 1.7626 // Excel: 1.7625851248497797
  },
  {
    id: 5,
    model: "IP 530",
    name: "Alas Aerosol Yangın Söndürücü 530 Gram",
    name_en: "Alas Aerosol Fire Extinguisher 530 Gram",
    weight_kg: "3,3±0,25",
    dimensions_mm: "219*99*99",
    width_mm: 219.0,
    depth_mm: 99.0,
    height_mm: 99.0,
    effective_mass: 371, // 530 * 0.7
    min_height: 1.2, // Excel: En Düşük Montaj Yüksekliği 120cm
    max_height: 2.5, // Deniz bey talebi: 3.5m → 2.5m (pratik kullanım için)
    mass: 3.3,
    contained_agent: 530,
    effective_mass_percentage: 70, // Excel'de 0.7 olarak görünüyor ama %70
    safe_distance: 1.2, // Excel'de 120cm -> 1.2m
    class_a_capacity: 7.4573, // Excel: 7.457286432160804
    class_b_capacity: 4.9539 // Excel: 4.953932434236881
  },
  {
    id: 6,
    model: "IP 1400",
    name: "Alas Aerosol Yangın Söndürücü 1400 Gram",
    name_en: "Alas Aerosol Fire Extinguisher 1400 Gram",
    weight_kg: "13,5±0,3",
    dimensions_mm: "246*239*247",
    width_mm: 246.0,
    depth_mm: 239.0,
    height_mm: 247.0,
    effective_mass: 840, // 1400 * 0.6
    min_height: 1.5, // Excel: En Düşük Montaj Yüksekliği 150cm
    max_height: 2.86, // Excel: En Yüksek Montaj Yüksekliği 286cm
    mass: 13.5,
    contained_agent: 1400,
    effective_mass_percentage: 60, // Excel'de 0.6 olarak görünüyor ama %60
    safe_distance: 1.5, // Excel'de 150cm -> 1.5m
    class_a_capacity: 16.8844, // Excel: 16.884422110552762
    class_b_capacity: 11.2165 // Excel: 11.216450794498598
  },
  {
    id: 7,
    model: "IP 2300",
    name: "Alas Aerosol Yangın Söndürücü 2300 Gram",
    name_en: "Alas Aerosol Fire Extinguisher 2300 Gram",
    weight_kg: "24,5±0,5",
    dimensions_mm: "244*322*324",
    width_mm: 244.0,
    depth_mm: 322.0,
    height_mm: 324.0,
    effective_mass: 1380, // 2300 * 0.6
    min_height: 2.0, // Excel: En Düşük Montaj Yüksekliği 200cm
    max_height: 2.86, // Excel: En Yüksek Montaj Yüksekliği 286cm
    mass: 24.5,
    contained_agent: 2300,
    effective_mass_percentage: 60, // Excel'de 0.6 olarak görünüyor ama %60
    safe_distance: 2.3, // Excel'de 230cm -> 2.3m
    class_a_capacity: 27.7387, // Excel: 27.738693467336685
    class_b_capacity: 18.4270 // Excel: 18.427026305247697
  },
  {
    id: 8,
    model: "IP 3500",
    name: "Alas Aerosol Yangın Söndürücü 3500 Gram",
    name_en: "Alas Aerosol Fire Extinguisher 3500 Gram",
    weight_kg: "26,5±0,5",
    dimensions_mm: "268*322*324",
    width_mm: 268.0,
    depth_mm: 322.0,
    height_mm: 324.0,
    effective_mass: 2100, // 3500 * 0.6
    min_height: 2.1, // Rapor uyumluluğu: 210cm 
    max_height: 3.42, // Excel: En Yüksek Montaj Yüksekliği 342cm
    mass: 26.5,
    contained_agent: 3500,
    effective_mass_percentage: 60, // Excel'de 0.6 olarak görünüyor ama %60
    safe_distance: 2.55, // Excel'de 255cm -> 2.55m
    class_a_capacity: 42.2111, // Excel: 42.21105527638191
    class_b_capacity: 28.0411 // Excel: 28.041126986246496
  },
  {
    id: 9,
    model: "IP 4600",
    name: "Alas Aerosol Yangın Söndürücü 4600 Gram",
    name_en: "Alas Aerosol Fire Extinguisher 4600 Gram",
    weight_kg: "32±0,5",
    dimensions_mm: "316*322*324",
    width_mm: 316.0,
    depth_mm: 322.0,
    height_mm: 324.0,
    effective_mass: 2760, // 4600 * 0.6
    min_height: 2.3, // Excel: En Düşük Montaj Yüksekliği 230cm
    max_height: 4.5, // Excel: En Yüksek Montaj Yüksekliği 450cm
    mass: 32,
    contained_agent: 4600,
    effective_mass_percentage: 60, // Excel'de 0.6 olarak görünüyor ama %60
    safe_distance: 2.3, // Excel'de 230cm -> 2.3m
    class_a_capacity: 55.4774, // Excel: 55.47738693467337
    class_b_capacity: 36.8541 // Excel: 36.854052610495394
  },
  {
    id: 10,
    model: "IP 6100",
    name: "Alas Aerosol Yangın Söndürücü 6100 Gram",
    name_en: "Alas Aerosol Fire Extinguisher 6100 Gram",
    weight_kg: "35,5±0,5",
    dimensions_mm: "354*322*324",
    width_mm: 354.0,
    depth_mm: 322.0,
    height_mm: 324.0,
    effective_mass: 3660, // 6100 * 0.6
    min_height: 2.5, // Rapor uyumluluğu: 250cm
    max_height: 6.0, // Excel: En Yüksek Montaj Yüksekliği 600cm
    mass: 35.5,
    contained_agent: 6100,
    effective_mass_percentage: 60, // Excel'de 0.6 olarak görünüyor ama %60
    safe_distance: 3.0, // Excel'de 300cm -> 3.0m
    class_a_capacity: 73.5678, // Excel: 73.5678391959799
    class_b_capacity: 48.8717 // Excel: 48.87167846174389
  },
  {
    id: 99,
    model: "AFS-CON1",
    name: "Alas Aerosol Sıralayıcı Elektronik Modül",
    name_en: "Alas Aerosol Sequential Electronic Module",
    weight_kg: "",
    dimensions_mm: "",
    width_mm: 0,
    depth_mm: 0,
    height_mm: 0,
    effective_mass: 0,
    min_height: 0,
    max_height: Infinity,
    mass: 0,
    isController: true,
    class_a_capacity: 0,
    class_b_capacity: 0
  }
];

// Ürün ID'sine göre ürün verilerini döndüren yardımcı fonksiyon
export const getProductById = (productId) => {
  const id = parseInt(productId);
  return productData.find(product => product.id === id) || null;
};

// Tüm ürün verilerini döndüren fonksiyon
export const getAllProducts = () => {
  return productData;
};

// Kontrol modülü olmayan ürünleri döndüren fonksiyon
export const getExtinguisherProducts = () => {
  return productData.filter(product => !product.isController);
};

// Dile göre ürün adını döndüren fonksiyon
export const getProductName = (product, language = 'tr') => {
  if (!product) return '';
  return language === 'en' ? product.name_en : product.name;
};

// Dile göre ürün adı ve model birleşimi döndüren fonksiyon
export const getProductDisplayName = (product, language = 'tr') => {
  if (!product) return '';
  const productName = getProductName(product, language);
  return `${product.model} - ${productName}`;
};

// Dile göre kısa ürün adını döndüren fonksiyon (sadece model)
export const getProductShortName = (product, language = 'tr') => {
  if (!product) return '';
  return product.model || getProductName(product, language).split(' ')[0];
};

export default productData; 